module.exports = __webpack_public_path__ + "img/u1105.png";